import { camelCase, deburr, kebabCase, upperFirst } from "lodash-es";

export { default as slugify } from "@sindresorhus/slugify";
export { camelCase, capitalize, deburr, kebabCase, padStart, snakeCase, trim, trimStart, truncate } from "lodash-es";

export function pascalCase(str: string) {
  return upperFirst(camelCase(str));
}

export function dotCase(str: string) {
  return kebabCase(str).replace(/-/g, ".");
}

export function safeDecode(v?: string | null): string {
  if (!v) return "";
  try {
    return decodeURIComponent(v);
  } catch {
    return v;
  }
}

export function safeEncode(v?: string | null): string {
  if (!v) return "";
  try {
    return encodeURIComponent(v);
  } catch {
    return v;
  }
}

export function normalizeForSearch(str: string): string {
  return deburr(str)
    .replace(/[^\w\s]/g, "")
    .replace(/\b(na|do|z|i|oraz|badan|badanie|badania|pakiet|pakietu|pakietów)\b/g, "")
    .toLowerCase();
}
